import { Routes } from "@angular/router";
import { AdminLayoutComponent } from "../shared/layouts/admin-layout/admin-layout.component";
import { LoginComponent } from "../features/account/login/login.component";
import { ForgotComponent } from "../features/account/forgot/forgot.component";
import { LandingPageComponent } from "../features/app/landing-page/landing-page.component";
import { VerifyCodeComponent } from "../features/account/verify-code/verify-code.component";
import { DashboardComponent } from "../features/admin/dashboard/dashboard.component";
import { LobbiesComponent } from "../features/admin/lobbies/lobbies.component";
import { UsersComponent } from "../features/admin/users/users.component";
import { ThemesComponent } from "../features/admin/themes/themes.component";
import { PartnersComponent } from "../features/admin/partners/partners.component";
import { SettingsComponent } from "../features/admin/settings/settings.component";
import { ResetPasswordComponent } from "../features/account/reset-password/reset-password.component";
import { ProfileDetailComponent } from "../features/app/profile-detail/profile-detail.component";
import { LoggerComponent } from "../features/admin/logger/logger.component";
import { VoilationReportsComponent } from "../features/admin/voilation-reports/voilation-reports.component";
import { adminGuard, redirectIfAuthenticated, resetAccessGuard } from "../Utils/_guards/auth.guard";
import { PrivacyPolicyComponent } from "../features/app/privacy-policy/privacy-policy.component";
import { TermsOfServicesComponent } from "../features/app/terms-of-services/terms-of-services.component";
import { CookiePoliciesComponent } from "../features/app/cookie-policies/cookie-policies.component";
import { ComingSoonComponent } from "../features/app/comming-soon/coming-soon.component";
import { VerificationRequestsComponent } from "../features/admin/verification-requests/verification-requests.component";
import { PaymentTransactionsComponent } from "../features/admin/payment-transactions/payment-transactions.component";
import { WaitlistedUserComponent } from "../features/admin/waitlisted-user/waitlisted-user.component";
import { SafetyPolicyComponent } from "../features/app/safety-policy/safety-policy.component";
import { NotificationManagementComponent } from "../features/admin/notification-management/notification-management.component";
import { OnboardingImagesComponent } from "../features/admin/onboarding-images/onboarding-images.component";

export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: ComingSoonComponent,
    // component: LandingPageComponent,
  },
  {
    path: "admin",
    component: AdminLayoutComponent,
    canActivate: [adminGuard],
    children: [
      { path: "", component: DashboardComponent },
      { path: "dashboard", component: DashboardComponent },
      { path: "users", component: UsersComponent },
      { path: "verification-requests", component: VerificationRequestsComponent },
      { path: "partners", component: PartnersComponent },
      { path: "payment-transactions", component: PaymentTransactionsComponent },
      { path: "settings", component: SettingsComponent },
      { path: "profile", component: ProfileDetailComponent },
      { path: 'logs', component: LoggerComponent },
      { path: 'voilation-report', component: VoilationReportsComponent },
      { path: 'waitlisted-user', component: WaitlistedUserComponent},
      { path: 'notification-management', component: NotificationManagementComponent },
      { path: 'brand-images', component: OnboardingImagesComponent }
    ],
  },
  { path: "privacy-policy", component: PrivacyPolicyComponent },
  { path: "terms-of-services", component: TermsOfServicesComponent },
  { path: "cookie-policy", component: CookiePoliciesComponent },
  { path: "safety-policy", component: SafetyPolicyComponent },
  {
    path: "auth",
    children: [
      { path: "", redirectTo: "login", pathMatch: "full" },
      { path: "login", component: LoginComponent },
      { path: "forgot-password", component: ForgotComponent },
      { path: "reset-password", component: ResetPasswordComponent }
    ]
  },
  { path: "**", redirectTo: "" },
];
